import { createRoute } from '@tanstack/react-router';

import { TravelerAccessPage } from '@web/ui/traveler_access';

import { settingsLayoutRoute } from './settings_routes';
import { ensureOrgPermission } from './view_as_routes';

export function ensureCanAuditTravelerAccess(orgSlug: string): Promise<void> {
  return ensureOrgPermission(orgSlug, 'kanban:traveler_access:audit');
}

/**
 * `/orgs/$orgSlug/settings/traveler-access` — the "ver como viajante" audit
 * trail: who viewed a traveler, or what an operator viewed. Lookups are exact
 * ids typed into the page; nothing searched travels in this URL.
 */
export const travelerAccessRoute = createRoute({
  getParentRoute: () => settingsLayoutRoute,
  path: 'traveler-access',
  beforeLoad: ({ params }) => ensureCanAuditTravelerAccess(params.orgSlug),
  component: TravelerAccessPage,
});
